define('lib/theme/ColorSchemeHandler',['require','marionette','less','Config'],function (require) {

    var Marionette = require('marionette');
    var Less = require('less');
    var Config = require('Config');

    return Marionette.Object.extend({

        _styleNodes: {},
        //_styleNodeRtl: null,
        _lessData: null,
        //_lessDataRtl: null,
        _themeSettings: null,

        initialize: function () {
            this._themeSettings = this.getOption('themeSettings');

            this.parseLess();
        },

        parseLess: function () {
            if (!this._styleNodes.color) {
                this.loadLess();
            }

            this._addStyles(this._lessData, this._getStyleNode('color'));
            /*if (Config.getInstance().getOption('is_rtl')) {
                this.parseLessRtl();
            }*/
        },

        /*parseLessRtl: function () {
            this._addStyles(this._lessDataRtl, this._getStyleNode('rtl'));
        },*/

        loadLess: function () {
            var instance = this;
            var revision = Config.getInstance().getOption('revision');
            jQuery.get('/v2/themes/' + this.getOption('theme') + '/css/color-styles.less?r=' + revision, function (lessData) {
                instance._lessData = lessData;
                instance.parseLess();
                /*if (Config.getInstance().getOption('is_rtl')) {
                    jQuery.get('/v2/themes/' + instance.getOption('theme') + '/css/color-styles-rtl.less?r=' + revision, function (lessData) {
                        instance._lessDataRtl = lessData;
                        instance.parseLessRtl();
                    });
                }*/
            });
        },

        _getStyleNode: function (pref) {
            if (!this._styleNodes[pref]) {
                this._styleNodes[pref] = jQuery('<style type="text/css"></style>');
                this._styleNodes[pref].appendTo(jQuery('head'));
            }
            return this._styleNodes[pref];
        },
        
        _addStyles: function (data, node) {
            if (data) {
                Less.render(data, {
                    globalVars: this._themeSettings.getThemeOptions(),
                    useFileCache: true
                }).then(function (css, aa,bb) {
                    node.html(css.css);
                }, function (err) {
                    console.log(err);
                });
            }
        }

    });

});
